export function generateRandomKey(): string {
  return `k${Math.random().toString(36).substring(2, 15)}${Math.round(
    Math.random() * 1000000,
  )}`;
}
